import './index.scss';

import React from 'react';

const Footer = () => {
  return (
    <div className="footer">
      <p>Copyright &copy; {new Date().getFullYear()} HomeFort. All rights reserved</p>
    </div>
  );
};

export default Footer;
